import React, { createRef, useState } from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table-6';
import { CSVLink } from 'react-csv';
import { MdSync } from 'react-icons/md';
import { AvgDeliveryRating } from './utils/ReportUtils';
import '../../styles/4-components/_react-table.scss';
import './OrderListTable.scss';
import 'react-table-6/react-table.css';
import { useTableHeight } from '../../hooks/useTableHeight';
import { reactTableToDataDownload } from './utils/reactTableToDataDownload';
import { ReqEnum } from 'const/requestStatus';
import { createCourierColumns } from './Columns/createCourierColumns';
import { ButtonComponent } from '../../ReusableComponents/Button/ButtonComponent';
import { DeliveryDetails } from '../../fetch/reportFetch';

const tableWrapper: any = createRef();
let reactTable: any = createRef();
let csvLink: any = createRef();

export function CourierReportListTable({
  deliveries,
  fetchStatus = ReqEnum.INIT,
}: {
  deliveries: DeliveryDetails[];
  fetchStatus: ReqEnum;
}): JSX.Element {
  const columns: any = createCourierColumns();
  const [tableHeight] = useTableHeight(tableWrapper);
  const [dataToDownload, setDataToDownload] = useState([]);

  const pagination = deliveries.length >= 100;

  function DownloadCSV() {
    const runDownload = async columns => {
      const data = reactTableToDataDownload(reactTable, columns);
      await setDataToDownload(data);
      if (data.length) {
        // click the CSVLink component to trigger the CSV download
        csvLink.link.click();
      }
    };

    return (
      <div className="orderlisttable__header__buttons u-screen-only">
        <ButtonComponent onClick={() => runDownload(columns)}>
          Download CSV
        </ButtonComponent>
        <CSVLink
          data={dataToDownload}
          filename="data.csv"
          className="hidden"
          ref={r => (csvLink = r)}
          target="_blank"
        />
      </div>
    );
  }

  return (
    <div
      className={
        fetchStatus === ReqEnum.PENDING
          ? 'orderlisttable is-loading'
          : 'orderlisttable'
      }
    >
      <div className="orderlisttable__header">
        <div className="orderlisttable__header__totals">
          <p>
            <em>Number of deliveries:</em> <span>{deliveries.length}</span>
          </p>
          <AvgDeliveryRating deliveries={deliveries} />
        </div>

        <DownloadCSV />
      </div>
      <div
        ref={tableWrapper}
        className="u-print-height-auto"
        style={{
          height: tableHeight,
        }}
      >
        <ReactTable
          ref={r => (reactTable = r)}
          data={deliveries}
          resizable={false}
          pageSize={pagination ? 100 : deliveries.length}
          showPagination={pagination}
          className="-striped -highlight"
          previousText="Back"
          nextText="Next"
          loadingText="Getting deliveries..."
          noDataText="Could not find any deliveries..."
          pageText="Page"
          ofText="of"
          rowsText="deliveries"
          // pageJumpText="gå til side"
          // rowsSelectorText="ordre per side"
          column={{
            ...ReactTableDefaults.column,
            minWidth: 0,
          }}
          columns={columns}
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]) === filter.value
          }
          filterable
        >
          {(state, makeTable, instance) => {
            let recordsInfoText = '';

            const { filtered, pageRows, pageSize, sortedData, page } = state;

            if (sortedData && sortedData.length > 0) {
              const isFiltered = filtered.length > 0;

              const totalRecords = sortedData.length;

              const recordsCountFrom = page * pageSize + 1;

              const recordsCountTo = recordsCountFrom + pageRows.length - 1;

              if (isFiltered)
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
              else
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
            } else recordsInfoText = 'No records';

            return (
              <div className="main-grid">
                <div className="above-table text-right">
                  <div className="col-sm-12">
                    <span className="records-info">{recordsInfoText}</span>
                  </div>
                </div>
                {makeTable()}
              </div>
            );
          }}
        </ReactTable>
      </div>
      <div className="orderlisttable__spinner">
        <MdSync />
      </div>
    </div>
  );
}
